<span class="checkmark">
    <svg class="icon icon--check" width="9" height="8" viewBox="0 0 9 8" aria-hidden="true" role="img" version="1.0">
        <path
            d="M10.0858278,5.07957526 L6.48708007,8.67806858 L5.04788631,7.23887482 C4.65042863,6.84141713 4.00615023,6.84141713 3.60843809,7.23887482 C3.21098041,7.6363325 3.21098041,8.28086535 3.60843809,8.67857749 L5.76722874,10.8366048 C6.16468642,11.2340625 6.80947373,11.2340625 7.20667696,10.8366048 L11.5250216,6.51851457 C11.9224793,6.12105689 11.9229882,5.47677849 11.5252761,5.07906635 C11.1280728,4.68237203 10.4832855,4.68237203 10.0858278,5.07957526 Z"
            transform="translate(-3 -4)"
        />
    </svg>
</span>
